

import React, { useState } from 'react';
import { toast } from 'sonner';
import { Plug } from 'lucide-react';


export default function IntegrationRequestForm({ connectors, onClose }) {
    const [selectedConnector, setSelectedConnector] = useState('');
    const [credentials, setCredentials] = useState('');
    const [additionalInfo, setAdditionalInfo] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      toast.success('Integration request submitted successfully!');
      onClose();
    };
  
    return (
      <div 
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{ backgroundColor: 'color-mix(in srgb, var(--color-bg) 70%, transparent)' }}
      >
        <div 
          className="p-6 shadow-xl w-full max-w-md"
          style={{
            backgroundColor: 'var(--color-surface)',
            borderColor: 'color-mix(in srgb, var(--color-muted) 50%, transparent)',
          }}
        >
          <h2 className="text-lg font-semibold mb-4 flex items-center gap-2" style={{ color: 'var(--color-primary)' }}>
            <Plug className="h-5 w-5" /> Request Data Integration
          </h2>
  
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Connector dropdown */}
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: 'var(--color-text)' }}>
                Select Connector
              </label>
              <select
                value={selectedConnector}
                onChange={(e) => setSelectedConnector(e.target.value)}
                required
                className="w-full px-3 py-2 border focus:outline-none"
                style={{
                  backgroundColor: 'var(--color-bg)',
                  borderColor: 'color-mix(in srgb, var(--color-muted) 50%, transparent)',
                  color: 'var(--color-text)',
                }}
              >
                <option value="">Choose a connector...</option>
                {connectors.map((conn) => (
                  <option key={conn.name} value={conn.name}>
                    {conn.name}
                  </option>
                ))}
              </select>
            </div>
  
            {/* Credentials */}
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: 'var(--color-text)' }}>
                Access Credentials
              </label>
              <input
                type="text"
                value={credentials}
                onChange={(e) => setCredentials(e.target.value)}
                placeholder="Enter credentials or token"
                className="w-full px-3 py-2 border focus:outline-none"
                style={{
                  backgroundColor: 'var(--color-bg)',
                  borderColor: 'color-mix(in srgb, var(--color-muted) 50%, transparent)',
                  color: 'var(--color-text)',
                }}
              />
            </div>
  
            {/* Additional information */}
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: 'var(--color-text)' }}>
                Additional Information
              </label>
              <textarea
                value={additionalInfo}
                onChange={(e) => setAdditionalInfo(e.target.value)}
                placeholder="Any notes or requirements..."
                rows={3}
                className="w-full px-3 py-2 border focus:outline-none resize-none"
                style={{
                  backgroundColor: 'var(--color-bg)',
                  borderColor: 'color-mix(in srgb, var(--color-muted) 50%, transparent)',
                  color: 'var(--color-text)',
                }}
              />
            </div>
  
            {/* Buttons */}
            <div className="flex justify-end gap-2 pt-2">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border transition-all duration-150"
                style={{
                  borderColor: 'color-mix(in srgb, var(--color-muted) 50%, transparent)',
                  backgroundColor: 'var(--color-surface)',
                  color: 'var(--color-muted)',
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 font-medium transition-all duration-150"
                style={{
                  backgroundColor: 'var(--color-primary)',
                  color: 'var(--color-surface)',
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }